import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { DataTableDirective } from 'angular-datatables';
import { BoardEvaluationService } from '../../../services/boardEvaluation.service';

import { Subject} from 'rxjs';
import _ = require('lodash');
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

import { AlertComponent } from '../../alert/alert.component';

declare var $: any;
declare var jQuery: any;
declare var autosize: any;

@Component({
  selector: 'app-questionMasterBoardEval',
  templateUrl: './questionMasterBoardEval.component.html',
  styleUrls: ['./questionMasterBoardEval.component.css'],
})
export class QuestionMasterBoardEvalComponent implements OnInit {
  questionForm: FormGroup;
  editquestionForm: FormGroup;
  questionMasterList: any[];
  evaluationTypeList: any[];
  evaluationCriteriaList: any[];
  evaluationType: any;
  evaluationCriteria: any;
  questionID: any;
  questionIdToDelete: any;
  editCriteriaId: any;
  evaluationevalCriteriaList: any[];
  disableSavebutton: boolean = false;
  disableupdatebutton: boolean = false;
  bulkUploadPreviewData: any[] = [];
  bulkUploadErrors: string[] = [];
  selectedBulkFile: File | null = null;
  isBulkUploading: boolean = false;

  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private alert: AlertComponent,
    private boardEvaluationService: BoardEvaluationService
  ) { }

  ngOnInit() {
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      // scrollY: "440px",
      // scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    this.questionForm = new FormGroup({
      // evaluationType: new FormControl('', [Validators.required]),
      evaluationCriteria: new FormControl('', [Validators.required]),
      questionText: new FormControl('', [Validators.required]),
      isGlobal: new FormControl('Company', [Validators.required]),
    });

    this.editquestionForm = new FormGroup({
      // editEvaluationType: new FormControl('', [Validators.required]),
      editEvaluationCriteria: new FormControl('', [Validators.required]),
      editQuestionText: new FormControl('', [Validators.required]),
      editIsGlobal: new FormControl('Company', [Validators.required]),
    });

    this.getQuestionMasterList();
    this.getEntityListDetails();
    this.getEvaluationCriteriaList();
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  getQuestionMasterList() {
    this.boardEvaluationService
      .getQuestionMasterBoardEvalList()
      .then((response) => {
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          if (_.size(response.questionList)) {
            this.questionMasterList = response.questionList;
            this.dtTrigger.next();
          } else {
            this.questionMasterList = [];
            this.dtTrigger.next();
          }
        } else {
          this.questionMasterList = [];
          this.dtTrigger.next();
        }
      });
  }

  getEntityListDetails() {
    // this.questionForm.reset();

    this.boardEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  showGetEntityListDetails() {
  //on click of button to show popup form..
  // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#questionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#questionMasterModal').modal('show');
    }, 100);

    this.boardEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  getEvaluationCriteriaList() {
    this.boardEvaluationService.getEvaluationCriteriaList().then((response) => {
      if (response.status == 0) {
        //console.log("criterialist new",response)
        if (_.size(response.evalCriteriaList)) {
          this.evaluationevalCriteriaList = response.evalCriteriaList;
        } else {
          this.evaluationevalCriteriaList = [];
        }
      } else {
        this.evaluationevalCriteriaList = [];
      }
    });
  }

  // getCriteriaListByEntityId(event) {
  //
  //   this.questionForm.controls.evaluationCriteria.setValue("");
  //   this.questionForm.controls.evaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.questionForm.controls.evaluationCriteria.",this.questionForm.controls.evaluationType.value)

  //   //console.log("event", event.target.value)
  //   this.boardEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  // getCriteriaListByEntityIdForEditForm(event) {
  //
  //   this.editquestionForm.controls.editEvaluationCriteria.setValue("");
  //   this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.questionForm.controls.evaluationCriteria.",this.editquestionForm.controls.editEvaluationCriteria.value)

  //   //console.log("event", event.target.value)
  //   this.boardEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  closeForm() {
    this.ngOnInit();
  }

  submitQuestionDetails() {
    this.disableSavebutton = true;
    try {
      const self = this;

      var isGlobal = this.questionForm.controls.isGlobal.value === 'Global';
      var questionObject = {
        EvaluationCriteriaID: this.questionForm.controls.evaluationCriteria.value,
        QuestionText: this.questionForm.controls.questionText.value.trim(),
        IsGlobal: isGlobal,
      };

      this.boardEvaluationService.addQuestionDetails(questionObject).then((response) => {
        this.disableSavebutton = false;

        if (response.status == 0) {

          $('#questionMasterModal').modal('hide');
          this.alert.successWithOk1(response.message, () => {
            ////inside popup form dialog
            $('#questionMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');


          });
          this.messagePopUpTimeoutToogle();
          this.questionForm.reset();
          this.getQuestionMasterList();
        } else {

          $('#questionMasterModal').modal('hide');
          this.alert.error1(response.message, () => {
            ////inside popup form dialog
            $('#questionMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

          });
           this.messagePopUpTimeoutToogle();
          this.questionForm.reset();
          this.getQuestionMasterList();
        }
      });
    } catch (error) { }
  }

  removeBackdrop() {
    // Manually remove any remaining modal backdrop
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  editQuestionDetails(selectedQuestionID) {
    if (selectedQuestionID != '') {
      //console.log("selectedQuestionID",selectedQuestionID)
      this.questionID = selectedQuestionID;
      // this.boardEvaluationService.getQuestionByQuestionID(this.questionID).then(response => {

      // if (response.status == 0) {
      this.editquestionForm.controls.editQuestionText.setValue(
        selectedQuestionID.QuestionText
      );

      // this.editquestionForm.controls.editEvaluationType.setValue(selectedQuestionID.EvaluationTypeID._id);
      // this.editquestionForm.controls.editEvaluationType.updateValueAndValidity();

      //console.log("hello edit function")
      // this.evaluationCriteriaList = response.evalCriteriaList;
      this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      this.editquestionForm.controls.editEvaluationCriteria.setValue(
        selectedQuestionID.EvaluationCriteriaID._id
      );
      this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      
      // Set IsGlobal value and disable if global
      var isGlobal = selectedQuestionID.IsGlobal === true;
      this.editquestionForm.controls.editIsGlobal.setValue(isGlobal ? 'Global' : 'Company');
      if (isGlobal) {
        this.editquestionForm.controls.editQuestionText.disable();
        this.editquestionForm.controls.editEvaluationCriteria.disable();
        this.editquestionForm.controls.editIsGlobal.disable();
      } else {
        this.editquestionForm.controls.editQuestionText.enable();
        this.editquestionForm.controls.editEvaluationCriteria.enable();
        this.editquestionForm.controls.editIsGlobal.enable();
      }
      // this.boardEvaluationService.getEvaluationCriteriaByEvalIdList(selectedQuestionID.EvaluationCriteriaID._id).then(response => {
      //   if (response.status == 0) {
      //     if (_.size(response.evalCriteriaList)) {
      //       //console.log("criteria")
      //       this.evaluationCriteriaList = response.evalCriteriaList;
      //       this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //       this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //       this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     } else {
      //       this.evaluationCriteriaList = [];
      //       this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //       this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //       this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     }
      //   } else {
      //     this.evaluationCriteriaList = [];
      //     this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //     this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //     this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //   }
      // });
      // this.editquestionForm.controls.questionText.disable();
      // this.editquestionForm.controls.editEvaluationType.disable();
      // this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID);

      $('#editingQuestionModal').modal('toggle');
    } else {
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertPopUpTitle').text('Failure!');
      $('#alertMessage').text('QUestion Selection Failure');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
    }
    //   });
    // } else {
    //   $('#alertPopUpTitle').css('color', '#f00');
    //   $('#alertPopUpTitle').text("Failure!");
    //   $('#alertMessage').text("Please select valid question.");
    //   $('#alertMessage').css('color', '#f00');
    //   $('#messagePopUp').modal('toggle');
    //   this.messagePopUpTimeoutToogle();
    //   this.questionForm.reset();
    // }
  }

  udpateQuestionDetails() {
    this.disableupdatebutton = true;
    const self = this;

    // Prevent editing global questions
    if (this.questionID.IsGlobal === true) {
      $('#editingQuestionModal').modal('toggle');
      $('#alertPopUpTitle').text('Failure!');
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertMessage').text('Global questions cannot be edited.');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
      return;
    }
    
    var questionObject = {
      evaluationQuestionID: this.questionID._id,
      // EvaluationTypeID: this.editquestionForm.controls.editEvaluationType.value,
      EvaluationCriteriaID:
        this.editquestionForm.controls.editEvaluationCriteria.value,
      questionText:
        this.editquestionForm.controls.editQuestionText.value.trim(),
    };
    //console.log("questionObject",questionObject);

    this.boardEvaluationService
      .updateEvaluationQuestionDetails(questionObject)
      .then((response) => {
        this.disableupdatebutton = false;
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text('Question text updated successfully.');
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editquestionForm.reset();
        } else {
          $('#questionMasterTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editquestionForm.reset();
        }
      });
  }

  editquestionTextChange(event) {
    if (event.target.value.trim() == '') {
      this.editquestionForm.controls.editQuestionText.setValue(
        event.target.value.trim()
      );
      this.editquestionForm.controls.editQuestionText.updateValueAndValidity();
    }
  }

  questionFormquestionTextChange(event) {
    if (event.target.value.trim() == '') {
      //console.log("event.target.value",event.target)
      this.questionForm.controls.questionText.setValue(
        event.target.value.trim()
      );
      this.questionForm.controls.questionText.updateValueAndValidity();
    }
  }

  deleteQuestionIdToPass(question) {
    // Prevent deleting global questions
    if (question.IsGlobal === true) {
      $('#alertPopUpTitle').text('Failure!');
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertMessage').text('Global questions cannot be deleted.');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
      return;
    }
    
    this.questionIdToDelete = question._id;
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#deleteQuestionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#deleteQuestionMasterModal').modal('show');
    }, 100);
  }

  deleteQuestionDetails() {
    //console.log(" this.questionIdToDelete", this.questionIdToDelete);
    this.boardEvaluationService.deleteQuestionDetails(this.questionIdToDelete)
      .then((response) => {
        // Hide the modal and remove any remaining backdrops
        $('#deleteQuestionMasterModal').modal('toggle');
        this.removeBackdrop(); // Manually remove any leftover backdrops

        // Set alert details based on response status
        const isSuccess = response.status == 0;
        const alertColor = isSuccess ? 'black' : '#f00';
        const alertTitle = isSuccess ? 'Success!' : 'Failure!';
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
        } else {
          $('#questionMasterTable').DataTable().destroy();
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();

        }

        // Refresh question list
        this.getQuestionMasterList();
        this.getEntityListDetails();
      });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  editCriteria(event) {
    //console.log("event", event.target.value)
  }

  // Bulk upload utilities
  openBulkUploadModal() {
    this.resetBulkUploadState();
    setTimeout(() => $('#questionBulkUploadModal').modal('show'), 100);
  }

  closeBulkUploadModal() {
    $('#questionBulkUploadModal').modal('hide');
    this.resetBulkUploadState();
  }

  downloadBulkUploadTemplate() {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Global/Company*', 'Evaluation Criteria*', 'Question Text*']
    ]);
    worksheet['!cols'] = [{ wch: 15 }, { wch: 35 }, { wch: 80 }];
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Questions');

    const instructions = [
      { Field: 'Global/Company*', Description: 'Type "Global" or "Company" exactly. Global questions are visible to all companies but cannot be edited.', Example: 'Company' },
      { Field: 'Evaluation Criteria*', Description: 'Exact criteria name as shown in the dropdown.', Example: 'Board Composition' },
      { Field: 'Question Text*', Description: 'Question statement to be displayed under that criteria.', Example: 'How comfortable are you with the current board mix?' },
      { Field: 'Note', Description: 'Fields marked with * are mandatory. Ensure spelling matches existing criteria.', Example: '' }
    ];
    const instructionsSheet = XLSX.utils.json_to_sheet(instructions);
    instructionsSheet['!cols'] = [{ wch: 25 }, { wch: 70 }, { wch: 70 }];
    XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'Instructions');

    const date = new Date();
    const fileName = `BoardEval_Questions_Template_${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  }

  onBulkUploadFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) {
      return;
    }
    this.selectedBulkFile = file;
    this.parseBulkUploadFile(file);
  }

  private parseBulkUploadFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        if (!jsonData.length) {
          this.bulkUploadErrors = ['Uploaded file is empty.'];
          this.bulkUploadPreviewData = [];
          return;
        }
        this.validateAndPrepareQuestions(jsonData);
      } catch (error) {
        console.error('Error parsing file:', error);
        this.bulkUploadErrors = ['Unable to read the Excel file. Ensure it is a valid .xlsx file.'];
        this.bulkUploadPreviewData = [];
      }
    };
    reader.readAsArrayBuffer(file);
  }

  private validateAndPrepareQuestions(rows: any[]) {
    this.bulkUploadPreviewData = [];
    this.bulkUploadErrors = [];

    rows.forEach((row, index) => {
      const rowNumber = index + 2;
      const globalCompany = (row['Global/Company*'] || '').toString().trim();
      const criteriaName = (row['Evaluation Criteria*'] || '').toString().trim();
      const questionText = (row['Question Text*'] || '').toString().trim();
      const errors: string[] = [];

      if (!globalCompany || !['Global', 'Company'].includes(globalCompany)) {
        errors.push(`Row ${rowNumber}: Global/Company must be either "Global" or "Company".`);
      }
      if (!criteriaName) {
        errors.push(`Row ${rowNumber}: Evaluation Criteria is required.`);
      }
      if (!questionText) {
        errors.push(`Row ${rowNumber}: Question Text is required.`);
      }

      const criteriaId = this.findCriteriaIdByName(criteriaName);
      if (criteriaName && !criteriaId) {
        errors.push(`Row ${rowNumber}: Criteria "${criteriaName}" not found.`);
      }

      this.bulkUploadPreviewData.push({
        rowNumber,
        IsGlobal: globalCompany === 'Global',
        EvaluationCriteriaName: criteriaName,
        EvaluationCriteriaID: criteriaId,
        QuestionText: questionText,
        hasError: errors.length > 0
      });
      this.bulkUploadErrors.push(...errors);
    });
  }

  processBulkUpload() {
    if (!this.bulkUploadPreviewData.length) {
      this.alert.error('Please upload a file with at least one question.');
      return;
    }
    if (this.bulkUploadErrors.length) {
      this.alert.error('Resolve validation errors before uploading.');
      return;
    }

    this.isBulkUploading = true;
    const createRequests = this.bulkUploadPreviewData.map(item => this.createQuestionFromBulk(item));

    Promise.all(createRequests)
      .then(results => {
        const successCount = results.filter(r => r).length;
        const failCount = results.length - successCount;

        this.getQuestionMasterList();
        this.closeBulkUploadModal();

        if (failCount === 0) {
          this.alert.success(`${successCount} question${successCount !== 1 ? 's' : ''} uploaded successfully.`);
        } else {
          this.alert.error(`Uploaded ${successCount} question${successCount !== 1 ? 's' : ''}. Failed: ${failCount}. Check console for details.`);
        }
      })
      .catch(error => {
        console.error('Bulk upload failed:', error);
        this.alert.error('Bulk upload failed. Please try again.');
      })
      .finally(() => {
        this.isBulkUploading = false;
      });
  }

  private createQuestionFromBulk(item: any): Promise<boolean> {
    if (!item?.EvaluationCriteriaID) {
      return Promise.resolve(false);
    }
    const payload = {
      EvaluationCriteriaID: item.EvaluationCriteriaID,
      QuestionText: item.QuestionText,
      IsGlobal: item.IsGlobal === true || item.IsGlobal === 'Global'
    };

    return this.boardEvaluationService.addQuestionDetails(payload)
      .then(response => {
        if (response.status === 0) {
          return true;
        }
        console.error(`Failed to create question "${item.QuestionText}": ${response.message}`);
        return false;
      })
      .catch(error => {
        console.error(`Error creating question "${item.QuestionText}":`, error);
        return false;
      });
  }

  private findCriteriaIdByName(name: string): string | null {
    if (!name) {
      return null;
    }
    const normalized = name.trim().toLowerCase();
    const match = this.evaluationevalCriteriaList?.find(
      (criteria) => criteria?.EvaluationCriteria?.trim().toLowerCase() === normalized
    );
    return match?._id || null;
  }

  private resetBulkUploadState() {
    this.bulkUploadPreviewData = [];
    this.bulkUploadErrors = [];
    this.selectedBulkFile = null;
    this.isBulkUploading = false;
    const input = document.getElementById('questionBulkFileInput') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }
}
